import { LOADER_DELAY } from '../config';

export class UsedLoaderModel {
  public timestamp: number = 0;
  public count: number = 0;

  //milliseconds
  readonly DELAY: number = LOADER_DELAY;

  public increment(): void {
    this.count += 1;
  }

  public decrement(): void {
    if (this.count > 0) {
      this.count -= 1;
    }
  }

  public getDelayTimeDifference(): number {
    let timestamp: number = new Date().getTime();

    return this.DELAY - (timestamp - this.timestamp);
  }

  public setTimestamp(): void {
    this.timestamp = new Date().getTime();
  }

  public isInTimeOfDelay(): boolean {
    let delayTimeDifference: number = this.getDelayTimeDifference();

    return delayTimeDifference > 0;
  }
}
